import { Injectable } from '@angular/core';

import { NotifyParams } from './notify-params.model';

import * as $ from 'jquery';
import * as _ from 'lodash';
import 'bootstrap-notify';

@Injectable()
export class NotifyService {
  // Defines the types of alerts used by the application.
  private alertTypes = ['error', 'info', 'success', 'warning', 'default', 'danger'];

  // Defines the types of icons used by the application due alert types.
  private iconTypes = ['remove circle', 'info circle', 'checkmark box', 'warning sign', 'comments outline', 'remove circle'];

  // Defines the delays types used by the application due alert types.
  private delayTypes = ['error', 'info', 'warning', 'danger'];

  constructor() { }

  // Display a notify message of the type INFO.
  info(params: NotifyParams) {
    return this.notify(_.assign({ type: 'info' }, params));
  }

  // Display a notify message of the type WARNING.
  warning(params: NotifyParams) {
    return this.notify(_.assign({ type: 'warning' }, params));
  }

  // Display a notify message of the type QUESTION.
  question(params: NotifyParams) {
    return this.notify(_.assign({ type: 'question' }, params));
  }

  // Display a notify message of the type SUCCESS.
  success(params: NotifyParams) {
    return this.notify(_.assign({ type: 'success' }, params));
  }

  // Display a notify message of the type ERROR.
  error(params: NotifyParams) {
    return this.notify(_.assign({ type: 'error' }, params));
  }

  // Private method that allows display notifications messages through info, warning, question, success and error public methods.
  private notify(params: NotifyParams) {
    // Sets the icon due type of message.
    const iconName = this.iconTypes[this.alertTypes.indexOf(params.type)];

    // Defines the content for title of message.
    const messageTitle = params.title || (['success', 'info'].includes(params.type) ? '' : 'Atenção!');

    // Defines the delay of dismiss messages.
    const delay = params.delay || this.delayTypes.includes(params.type) ? 0 : 10000;

    // Execute the notify with informed params.
    ($ as any).notify({
      icon: `${iconName} icon`,
      title: `${ messageTitle }`,
      message: params.message,
      closeOnConfirm: true
    }, {
      type: '${ params.type }',
      allow_dismiss: true,
      newest_on_top: true,
      showProgressbar: true,
      mouse_over: 'pause',
      placement: {
        from: "top",
        align: "right"
      },
      offset: {
        x: 28,
        y: 60
      },
      spacing: 10,
      delay: parseInt(`${ delay }`),
      timer: 1000,
      animate: {
        enter: 'animated bounceInDown',
        exit: 'animated bounceOutUp'
      },
      template: `
        <div data-notify="container" #notifyContainer
          class="col-11 col-sm-6 col-md-5 col-xl-4 alert alert-${ params.type }"
          role="alert"
          id="notify-container">
          <div class="ui icon ${ params.type } message z-depth-2">
            <button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>
            <i class="${ iconName } icon"></i>
            <div class="content">
              <div class="header">
                {1}
              </div>
              {2}
            </div>
          </div>
          <div class="progress-bar" data-notify="progressbar">
            <div class="progress-bar progress-bar-${ params.type }"
            role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
            style="width: 0%;">
            </div>
          </div>
        </div>
      `
    });
  }
}


  // # Setting to close the messages of semantic-ui.
  // $('[data-notify="container"]').on 'click', '.message .close', ->
  //   $(this).closest(".message").closest('[data-notify="container"]').addClass('animated bounceOutUp')
  //   return
